export const goldMarketRial = priceToman => Math.round(Number(priceToman || 0) * 10);

export const goldBuybackRial = priceToman => Math.round(Number(priceToman || 0) * 0.99) * 10;

export const goldOrderTotalRial = (gram, priceToman) =>
  Math.round(Number(gram || 0) * goldMarketRial(priceToman));
